module.exports = __webpack_public_path__ + "images/foot-glitches.png";